import { nvlDateTypeReturnToString } from 'utils/nvl';
import { moduleScnMap } from 'utils/code';

export function makeDataLevel(d, pageIndex, pageSize, index) {
  return {
    index: (pageIndex * pageSize) + index + 1,
    dispensingIdx: d.dispensingIdx,
    userNm: d.userNm ? d.userNm : '',
    userTel: d.userTel ? d.userTel : '',
    instNm: d.instNm ? d.instNm : '',
    partner: d.partner ? d.partner : '',
    moduleIdx: d.module ? d.module.moduleIdx : '',
    modelNo: d.module ? d.module.modelNo : '',
    modelNm: d.module ? d.module.modelNm : '',
    moduleTypeNm: d.module.moduleType === "DT" ? "이동형" : "휴대형",
    moduleScnNm: d.module ? moduleScnMap[d.module.moduleScn + ''].viewTitle : '',
    areaNm: d.areaNm ? d.areaNm : '',
    xAxis: d.xaxis,
    yAxis: d.yaxis,
    rgstId: d.rgstId,
    dispensingDt: nvlDateTypeReturnToString(d.dispensingDt, ''),
    receivingDt: nvlDateTypeReturnToString(d.receivingDt, '')
  }
}
